import { Contract, ContractTenant } from '../../../../../../common/validations'
import {
  TerminateSuggestion,
  TerminateSuggestionAction,
} from '../../../../ContractChanges/hooks/useTerminateSuggestions'
import { isChildTenant } from '../../../../ContractChanges/utils/isChildTenant'
import { isMoveOutDisabled } from '../../../../ContractChanges/utils/isMoveOutDisabled'

type IsSuggestionDisabledParams = {
  suggestion: TerminateSuggestion
  contract: Contract
  tenant: ContractTenant
  terminateTenantIds: number[]
  contractModification: boolean
}

export const isSuggestionDisabled = ({
  suggestion,
  contract,
  tenant,
  terminateTenantIds,
  contractModification,
}: IsSuggestionDisabledParams) => {
  const isCurrentTenant = tenant.id === contract.tenant.id
  const { terminationDisallowedReason } = contract
  const isInEffectSuggestion =
    suggestion.id === TerminateSuggestionAction.IN_EFFECT

  if (isInEffectSuggestion) {
    return false
  }

  if (terminationDisallowedReason) {
    return isMoveOutDisabled(contract, tenant)
  }

  if (isCurrentTenant) {
    return false
  }

  if (!contractModification) {
    return true
  }

  if (isChildTenant(tenant)) {
    return false
  }

  return !terminateTenantIds.includes(contract.tenant.id)
}
